import React, { useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import '../css/OtherActions.css';
import CategoryComponent from './CategoryComponent';
import BrandComponent from './BrandComponent';
import PowerComponent from './PowerComponent';
import CurrentComponent from './CurrentComponent';
import PulseComponent from './PulseComponent';
import VoltageComponent from './VoltageComponent';
import ProductComponent from './ProductComponent';

const OtherActions = () => {
    const tabs = useMemo(
        () => [
            'Category',
            'Brand',
            'Power',
            'Voltage',
            'Current',
            'Pulse Per Revolution',
            'Products',
        ],
        []
    );
    const [handleView, setHandleView] = useState('Category');

    return (
        <section className="other-actions">
            <header className="other-actions-header">
                <h2 className="other-actions-title">Other actions</h2>
                <p className="other-actions-subtitle">
                    Manage reference values and supporting product data.
                </p>
            </header>

            <div className="other-actions-tabs" role="tablist" aria-label="Action groups">
                {tabs.map((button) => (
                    <motion.button
                        key={button}
                        type="button"
                        role="tab"
                        aria-selected={handleView === button}
                        className={`other-actions-tab${
                            handleView === button ? ' other-actions-tab--active' : ''
                        }`}
                        initial={{ y: 8 }}
                        animate={{ y: 0 }}
                        whileHover={{ y: -1 }}
                        whileTap={{ scale: 0.98 }}
                        onClick={() => setHandleView(button)}
                    >
                        {button}
                    </motion.button>
                ))}
            </div>

            <p className="other-actions-current">
                Viewing <strong>{handleView}</strong> items / values
            </p>

            <div className="other-actions-panel" role="tabpanel">
                {handleView === 'Category' && <CategoryComponent />}
                {handleView === 'Brand' && <BrandComponent />}
                {handleView === 'Power' && <PowerComponent />}
                {handleView === 'Voltage' && <VoltageComponent />}
                {handleView === 'Current' && <CurrentComponent />}
                {handleView === 'Pulse Per Revolution' && <PulseComponent />}
                {handleView === 'Products' && <ProductComponent />}
            </div>
        </section>
    );
};

export default OtherActions;